import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import SelectInput from '../../../../../../app/common/SelectInput';
import { t } from '../../../../../infra/i18n';
import { fullName } from '../../../../../../app/common/helpers/users';
export var BarberSelector = function (_a) {
    var barbers = _a.barbers, selectedBarberId = _a.selectedBarberId, onSelectedBarberChanged = _a.onSelectedBarberChanged;
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "c-label-new", children: t('admin:external_platforms.import_for_label') }), _jsx("div", { children: _jsx(SelectInput, { empty: t('admin:external_platforms.select_barber_placeholder'), options: barbers, valueField: "id", disabled: barbers.length === 0, textField: function (barber) { return fullName(barber); }, className: "c-select u-width-100", input: {
                        onChange: onSelectedBarberChanged,
                        value: selectedBarberId,
                    } }) })] }));
};
